import { defineHttpContract } from "@/shared/api/contracts";
import { InboxQueryParams, NotificationItem, NotificationPage } from "@/entities/notification/model/types";

export const notificationContracts = {
    inbox: defineHttpContract<NotificationPage, undefined, InboxQueryParams>({
        service: "notification",
        method: "GET",
        path: "/notification/in-box",
    }),

    markAsViewed: (notificationId: string) =>
        defineHttpContract<NotificationItem>({
            service: "notification",
            method: "PATCH",
            path: `/notification/in-box/${notificationId}/viewed`,
        }),

    disable: (notificationId: string) =>
        defineHttpContract<void>({
            service: "notification",
            method: "PATCH",
            path: `/notification/in-box/${notificationId}/disable`,
        }),
};
